import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./PagamentosCliente.css";
import { Button, Table, Select, DatePicker } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import "antd/dist/antd.css";
import * as links from "../../../../utils/links";

const formaPagamento = (tipo) => {
  const mapa = {
    bank_transfer: "PIX",
    CASH: "Espécie",
    debit_card: "Débito",
    credit_card: "Crédito",
    1: "Crédito",
    11: "PIX",
    8: "Débito",
  };
  return mapa[tipo] || "-";
};

const moeda = (valor) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(valor || 0));

const PagamentosCliente = () => {
  const { Option } = Select;
  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const [listCanals, setListCanals] = useState([]);
  const [total, setTotal] = useState(0);
  const [loadingTable, setLoadingTable] = useState(false);
  /* "Todos" significa todos os pagamentos do mês atual. */
  const [filtro, setFiltro] = useState("mesatual");
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);

  const { RangePicker } = DatePicker;

  const tratarErro = (err) => {
    if ([401, 403].includes(err?.response?.status)) {
      setNotiMessage({ type: "error", message: "A sua sessão expirou, para continuar faça login novamente." });
      navigate(dataUser?.key === "ADMIN" ? links.ADMIN_SIGNIN : links.SIGNIN);
      setDataUser(null);
      return;
    }
    setNotiMessage({ type: "error", message: "Não foi possível carregar os pagamentos agora." });
  };

  const getData = async (filtroAtual = filtro) => {
    if (filtroAtual === "periodo" && (!dataInicio || !dataFim)) return;

    let url = `${process.env.REACT_APP_SERVIDOR}/payments-client?filtro=${String(filtroAtual).toLowerCase()}`;
    if (filtroAtual === "periodo") {
      url += `&dataInicio=${dataInicio}T03:00:00.000Z`;
      const fim = new Date(`${dataFim}T12:00:00`);
      fim.setDate(fim.getDate() + 1);
      url += `&dataFim=${fim.toISOString().split("T")[0]}T03:00:00.000Z`;
    }

    setLoadingTable(true);
    try {
      const res = await axios.get(url, {
        headers: { "x-access-token": token, "content-type": "application/json" },
      });
      setTotal(Number(res?.data?.soma || 0));
      setListCanals(Array.isArray(res?.data?.pagamentosRecentes) ? res.data.pagamentosRecentes : []);
    } catch (err) {
      setTotal(0);
      setListCanals([]);
      tratarErro(err);
    } finally {
      setLoadingTable(false);
    }
  };

  useEffect(() => {
    if (filtro === "periodo") {
      setListCanals([]);
      setTotal(0);
      if (!dataInicio || !dataFim) {
        setNotiMessage({ type: "info", message: "Selecione a data inicial e final para consultar o período." });
      }
      return;
    }
    getData(filtro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  useEffect(() => {
    if (filtro === "periodo" && dataInicio && dataFim) getData("periodo");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataInicio, dataFim]);

  const columns = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (data) => <span>{moment(data).format("DD/MM/YYYY HH:mm:ss")}</span>,
    },
    {
      title: "Forma de pagamento",
      dataIndex: "tipo",
      key: "tipo",
      render: (tipo) => <span>{formaPagamento(tipo)}</span>,
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor) => moeda(valor),
    },
    {
      title: "Taxas",
      dataIndex: "taxas",
      key: "taxas",
      render: (taxas) => moeda(taxas),
    },
    { title: "Máquina", dataIndex: "maquinaNome", key: "maquinaNome" },
    { title: "Descrição", dataIndex: "maquinaDescricao", key: "maquinaDescricao" },
    { title: "Operadora", dataIndex: "operadora", key: "operadora" },
    { title: "Identificador", dataIndex: "mercadoPagoId", key: "mercadoPagoId" },
  ];

  return (
    <div className="Admin_PagamentosSearch_container pagamentos-cliente-page">
      <div className="Admin_PagamentosSearch_header pagamentos-cliente-header">
        <div className="Admin_PagamentosSearch_header_left pagamentos-cliente-filtros">
          <div className="Admin_Dashboard_staBlockTitle">Pagamentos Recentes</div>

          <div className="Admin_PagamentosSearch_datePicker pagamento-filtro-select">
            <Select value={filtro} onChange={setFiltro}>
              <Option value="mesatual">Todos</Option>
              <Option value="periodo">Período</Option>
              <Option value="ultimos7dias">Últimos 7 dias</Option>
              <Option value="mespassado">Mês Passado</Option>
            </Select>
          </div>

          <div className="Admin_PagamentosSearch_datePicker pagamento-filtro-periodo">
            <RangePicker
              disabled={filtro !== "periodo"}
              placeholder={["Data Inicial", "Data Final"]}
              onChange={(dates, dateStrings) => {
                setDataInicio(dateStrings?.[0] || null);
                setDataFim(dateStrings?.[1] || null);
              }}
            />
          </div>

          <Button className="Admin_PagamentosSearch_header_back" onClick={() => navigate(links.DASHBOARD_FORNECEDOR)}>
            VOLTAR
          </Button>
        </div>
      </div>

      <div className="pagamentos-periodo-info">
        {filtro === "mesatual" ? "Todos os pagamentos deste mês, de todas as máquinas da empresa." :
         filtro === "periodo" ? "Período personalizado escolhido por você." :
         filtro === "ultimos7dias" ? "Pagamentos dos últimos 7 dias." : "Pagamentos do mês passado."}
      </div>

      <div className="Admin_PagamentosSearch_body">
        <div className="Admin_PagamentosSearch_content">
          <div className="pagamentos-total-card">
            <span>Total</span>
            <strong>{moeda(total)}</strong>
          </div>

          <div className="pagamentos-desktop-table">
            <Table
              rowKey={(record, index) => record?.id || record?.mercadoPagoId || index}
              columns={columns}
              dataSource={listCanals}
              pagination={false}
              loading={loadingTable}
              scroll={{ x: 980 }}
              locale={{ emptyText: <div>Nenhum pagamento encontrado para esta seleção.</div> }}
            />
          </div>

          <div className="pagamentos-mobile-list">
            {loadingTable ? (
              <LoadingAction />
            ) : listCanals.length ? (
              listCanals.map((p, index) => (
                <article className="pagamento-mobile-card" key={p?.id || p?.mercadoPagoId || index}>
                  <div className="pagamento-mobile-topo">
                    <div>
                      <span>{p?.maquinaDescricao || p?.maquinaNome || "Máquina"}</span>
                      <small>{p?.maquinaNome || ""}</small>
                    </div>
                    <strong>{moeda(p?.valor)}</strong>
                  </div>
                  <div className="pagamento-mobile-grid">
                    <div><span>Data</span><strong>{moment(p?.data).format("DD/MM/YYYY HH:mm:ss")}</strong></div>
                    <div><span>Forma</span><strong>{formaPagamento(p?.tipo)}</strong></div>
                    <div><span>Taxas</span><strong>{moeda(p?.taxas)}</strong></div>
                    <div><span>Operadora</span><strong>{p?.operadora || "-"}</strong></div>
                    <div className="pagamento-mobile-id"><span>Identificador</span><strong>{p?.mercadoPagoId || "-"}</strong></div>
                  </div>
                </article>
              ))
            ) : (
              <div className="pagamentos-mobile-vazio">Nenhum pagamento encontrado para esta seleção.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagamentosCliente;
